module.exports = __webpack_public_path__ + "static/media/news.065d771d.png";